import styled from 'styled-components'

import { theme } from '../../../theme'

export const PropertyCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
`

export const ImageSection = styled.div`
  height: 200px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
`

export const PropertyImageStyled = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

export const PropertyDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const PropertyTitle = styled.h2`
  font-weight: ${theme.fontWeight.semiBold};
  font-size: 20px;
`

export const PropertyAddress = styled.p`
  font-weight: ${theme.fontWeight.light};
  font-size: 16px;
`

export const PropertySpecs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  margin-top: 1rem;
`

export const Spec = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: ${theme.fontWeight.light};
`

export const SpecIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.borderColor};
`

export const SectionTitle = styled.h3`
  font-family: ${theme.fonts.itcGothicPro};
  font-weight: ${theme.fontWeight.semiBold};
  font-size: 18px;
  color: ${theme.colors.primaryDefault};
  margin: 0;
`

export const TimeToLocationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const CommuteOptions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`

export const CommuteOption = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: ${theme.colors.lightBg};
  border-radius: 1000px;
  padding: 4px 16px;
  font-weight: ${theme.fontWeight.light};
`

export const DistanceText = styled.p`
  font-weight: ${theme.fontWeight.light};
  margin: 0;
`

export const CommentText = styled.p`
  font-weight: ${theme.fontWeight.light};
  font-size: 16px;
  color: ${theme.colors.primaryDefault};
  margin: 8px 0 0 0;
  line-height: 1.4;
`
